/**
 * Get color name based on form check score (0-100)
 * @param {number} score - Score value from 0 to 100
 * @returns {string} - Color name ('green', 'orange', or 'red')
 */
export const getFormScoreColorName = (score) => {
  if (score >= 70) {
    return 'green'
  }

  if (score >= 40) {
    return 'orange'
  }

  return 'red'
}
